import { memo } from "react";
import { removeDuplicates } from "../../../util/lodash/removeDuplicates";
import ManufacturerCard from "./ManufacturerCard";
import styles from "../accessories-make/accessories-make.module.scss";

function AllManufacturers(props: any) {
  const {
    modelsWithUrl, h1, h2, labelKey, renderChildren,
  } = props;

  return (
    <div className={styles.accessories_make}>

      <div className="accessories">

        <div className={`${styles.app_page_header} row`}>

          <span className={styles.heading}>

            <h1>
              {h1}
            </h1>
          </span>

          <span className={styles.subheading} />
        </div>

        <div className={`section ${styles.section_makes_models}`}>

          <div className={styles.heading}>{h2}</div>

          <ManufacturerCard
            renderChildren={renderChildren}
            labelKey={labelKey}
            data={removeDuplicates(modelsWithUrl, "url")}
          />
        </div>
      </div>
    </div>
  );
}

export default memo(AllManufacturers);
